import { WSService } from "../utils/WSService";

export const servicePayments = new WSService("/payments");
